module.exports = __webpack_public_path__ + "static/img/modernWeb191.02067b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/modernWeb19/modernWeb191.jpg
// module id = 3nkn
// module chunks = 1